import { isProduction } from 'modules/common/utils/env'

export const CLIENT_ID = 'compeon-file-upload'

export const AUTH_URL = isProduction ? 'https://login.compeon.de' : 'https://login.staging.compeon.de'
